// Hooks
import { useEffect, useState } from 'react';

// Next
import Image from 'next/image';

// Contentful
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { RENDER_DOCUMENT_OPTIONS, imageLoader } from '../../helpers/contentful';

// Components
import Pattern from '../Pattern/Pattern';

const StoriesBlock = (props) => {
  const { title, description, list } = props;

  const [patternOffset, setPatternOffset] = useState(0);

  const cardRefsObj = [];
  const setRef = (ref) => cardRefsObj.push(ref);

  const setPatternConfig = () => {
    if (cardRefsObj[1]) setPatternOffset(Math.floor(cardRefsObj[1].getBoundingClientRect().height));
  };

  useEffect(() => {
    setPatternConfig();
    const handleResize = () => setTimeout(() => setPatternConfig(), 1000);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="StoriesBlock">
      <div className="StoriesBlock-inner">
        <div className="StoriesBlock-grid">
          <div className="StoriesBlock-header">
            {title && (
              <h2 className="StoriesBlock-title">{documentToReactComponents(title, RENDER_DOCUMENT_OPTIONS)}</h2>
            )}
            {title && (
              <div className="StoriesBlock-description">
                {documentToReactComponents(description, RENDER_DOCUMENT_OPTIONS)}
              </div>
            )}
          </div>
          {list &&
            list.map((story, index) => (
              <div className="StoriesBlock-story" key={`StoriesBlock-story--${index}`}>
                <a href={story.url} target="_blank" rel="noopener noreferrer" className="StoriesBlock-storyLink">
                  <div className="StoriesBlock-storyHeader" ref={setRef}>
                    {story.title && <h3 className="StoriesBlock-storyTitle">{story.title}</h3>}
                    {story.description && (
                      <p className="StoriesBlock-storyDescription">
                        {story.description}{' '}
                        <svg className="StoriesBlock-arrow">
                          <use xlinkHref="#arrow-next" />
                        </svg>
                      </p>
                    )}
                  </div>
                  <div className="StoriesBlock-storyImage">
                    <Image
                      layout="responsive"
                      loader={imageLoader}
                      alt={story.title}
                      lazyBoundary="500px"
                      sizes="(min-width: 1440px) 620px, (min-width: 640px) 50vw, 100vw"
                      src={`https:${story.image.src}`}
                      height={story.image.height}
                      width={story.image.width}
                    />
                  </div>
                </a>
              </div>
            ))}

          <div className="StoriesBlock-pattern" style={{ marginTop: `${patternOffset}px` }}>
            <Pattern modifier="Pattern--pampasBeige" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoriesBlock;
